<pgh-modal-window class="mfe-pgh-device-inventory-styles mat-typography">
  <div modal-close>
    <div style="display: flex;width: 100%;position: relative;justify-content: flex-end;">
      <button mat-icon-button class="close-button mat-icon-button" sf-aria-label="Global_Close_Window" matDialogClose>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div modal-title>
    <div class="title-container">
      <div>
        <mat-icon style="color:#3C4D6A;height:64px;width:64px;overflow:visible !important;margin-top:5px;">
          <ng-container *ngTemplateOutlet="alertIcon"></ng-container>
        </mat-icon>
      </div>
      <div style="margin-top:25px;margin-left:25px;">
        <span style="color:#13223C;font-size:26px;font-weight:600;">{{title}}</span>
      </div>
    </div>
  </div>
  <div modal-body class="mfe-body-1 body-container" style="overflow-y:hidden;">
    <div>
      <span style="color:#3D515A;font-size:16px;font-weight:600;">{{message1}}</span>&nbsp;<span style="color:#3D515A;font-size:16px;font-weight:400;">{{message2}}</span>
    </div>
    <br>
    <div>
      <span style="color:#3D515A;font-size:16px;font-weight:400;">{{message3}}</span>
    </div>
  </div>
  <div modal-footer class="row">
    <div class="col-md-6">
      <button mat-stroked-button style="border-radius: 6px !important;" color="primary" class="border-0" (click)="onCancelClicked()">
        {{cancelButtonTitle}}
      </button>
    </div>
    <div class="button-container-mobile col-md-6">
      <button mat-flat-button style="border-radius: 6px !important;" color="accent" (click)="onContinueClicked()">
        {{confirmButtonTitle}}
      </button>
    </div>
  </div>
    <ng-template #alertIcon>
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="32" fill="#E16D01" fill-opacity="0.05"/>
        <path d="M31.9999 43.75C30.9666 43.75 30.125 42.9083 30.125 41.875C30.125 40.8417 30.9666 40 31.9999 40C33.0332 40 33.8748 40.8417 33.8748 41.875C33.8748 42.9083 33.0332 43.75 31.9999 43.75Z" fill="#E16D01"/>
        <path d="M31.9999 37.5C31.31 37.5 30.75 36.94 30.75 36.25V23.75C30.75 23.06 31.31 22.5 31.9999 22.5C32.6882 22.5 33.2499 23.06 33.2499 23.75V36.25C33.2499 36.9383 32.6882 37.5 31.9999 37.5Z" fill="#E16D01"/>
        <path d="M15.7882 50C15.2099 50 14.6333 49.865 14.1166 49.6117C13.2117 49.1667 12.5317 48.3933 12.2051 47.4367C11.8784 46.48 11.9434 45.4517 12.3901 44.5467L28.176 12.3817C28.5893 11.54 29.281 10.85 30.1209 10.4367C30.7109 10.1467 31.3409 10 31.9942 10C33.6341 10 35.1024 10.9117 35.824 12.3817L51.6117 44.545C51.865 45.0617 52 45.6383 52 46.2167C52 47.2283 51.605 48.18 50.8884 48.8933C50.1751 49.6067 49.2251 50 48.2152 50H15.7882ZM31.9959 12.5C31.7275 12.5 31.4659 12.56 31.2242 12.68C30.8776 12.85 30.5909 13.1367 30.4209 13.4833L14.6333 45.6483C14.32 46.285 14.5833 47.0567 15.2199 47.3683C15.3949 47.455 15.5899 47.5 15.7849 47.5H48.2135C48.5585 47.5 48.8801 47.3667 49.1235 47.125C49.3668 46.8817 49.5001 46.56 49.5018 46.2167C49.5018 46.02 49.4568 45.825 49.3701 45.65L33.5791 13.4833C33.2858 12.8867 32.6658 12.5 31.9959 12.5Z" fill="#E16D01"/>
      </svg>
    </ng-template>
</pgh-modal-window>
